module.exports = __webpack_public_path__ + "static/Stratyfy-7006c097a0432308030537e20f41d206.jpg";